import { NULL_SIX } from "@/data/series";
import { RedactedText } from "@/components/redaction/RedactedText";
import { FragmentProbe } from "@/components/secrets/FragmentProbe";

const STATS = [
  { k: "6.13 s", v: "missing, every time" },
  { k: "2,184", v: "confirmed dead at Aster Reach" },
  { k: "99.997%", v: "model confidence \u2014 wrong" },
  { k: "5", v: "civilisations, one \u2588\u2588\u2588\u2588\u2588\u2588" }
];

export const NullSixSection = () => (
  <section
    id="null-six"
    data-testid="null-six-section"
    className="relative z-10 scroll-mt-20 border-b border-border"
  >
    <div className="mx-auto max-w-6xl px-4 py-16 sm:px-6 sm:py-24">
      <div className="grid gap-10 lg:grid-cols-[0.95fr_1.05fr] lg:gap-14">
        <div>
          <p className="eyebrow">{NULL_SIX.kicker}</p>
          <h2 className="mt-3 text-3xl font-semibold leading-tight sm:text-[2.6rem]">
            {NULL_SIX.title}
          </h2>
          <p className="mt-5 text-[15px] leading-relaxed text-[hsl(210_14%_84%)] sm:text-base">
            <RedactedText text={NULL_SIX.lede} />
          </p>
          <p className="mt-4 text-[15px] leading-relaxed text-[hsl(210_12%_72%)] sm:text-base">
            <RedactedText text={NULL_SIX.body} />
          </p>

          <div className="mt-8 grid grid-cols-2 gap-3 sm:max-w-md">
            {STATS.map((stat) => (
              <div key={stat.k} className="panel-quiet px-3.5 py-3">
                <p className="font-mono text-lg tabular-nums text-[hsl(32_92%_66%)]">
                  {stat.k}
                </p>
                <p className="mt-1 font-mono text-[10px] uppercase leading-relaxed tracking-[0.13em] text-muted-foreground">
                  <RedactedText text={stat.v} />
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* paper insert: the recovered timeline */}
        <div className="paper p-5 sm:p-7">
          <div className="flex items-center justify-between gap-3 border-b border-[hsl(36_18%_74%)] pb-3">
            <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-[hsl(220_12%_38%)]">
              Exhibit 06-A · reconstructed timeline
            </p>
            <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-[hsl(2_72%_42%)]">
              Directorate copy
            </p>
          </div>

          <ol className="mt-5 space-y-0">
            {NULL_SIX.timeline.map((row, i) => {
              const rowCls = `relative grid grid-cols-[auto_1fr] gap-4 py-3.5 ${
                i > 0 ? "border-t border-[hsl(36_16%_80%)]" : ""
              }`;
              const inner = (
                <>
                  <span
                    className={`font-mono text-[11px] tabular-nums tracking-tight ${
                      row.gap
                        ? "font-semibold text-[hsl(2_72%_42%)]"
                        : "text-[hsl(220_12%_40%)]"
                    }`}
                  >
                    {row.time}
                  </span>
                  <span
                    className={`text-[13px] leading-relaxed ${
                      row.gap
                        ? "font-semibold text-[hsl(2_72%_38%)]"
                        : "text-[hsl(var(--ink))]"
                    }`}
                  >
                    <RedactedText text={row.event} tone="ink" />
                  </span>
                  {row.gap && (
                    <span className="absolute inset-x-0 -bottom-px h-px bg-[repeating-linear-gradient(90deg,hsl(2_72%_46%)_0_6px,transparent_6px_12px)]" />
                  )}
                </>
              );

              return row.gap ? (
                <FragmentProbe
                  key={row.time}
                  fragmentId="f2"
                  as="li"
                  label="Expand the Null Six row"
                  className={rowCls}
                >
                  {inner}
                </FragmentProbe>
              ) : (
                <li key={row.time} className={rowCls}>
                  {inner}
                </li>
              );
            })}
          </ol>

          <p className="mt-5 border-t border-[hsl(36_16%_80%)] pt-4 font-mono text-[10px] uppercase leading-relaxed tracking-[0.14em] text-[hsl(220_10%_44%)]">
            <RedactedText text={NULL_SIX.note} tone="ink" />
          </p>
        </div>
      </div>
    </div>
  </section>
);
